import { SingletonConfig } from "../SingletonConfig";

export const infoGlobal = {
    
    GetImagenesTarjetas: function () {
    let config = null;

    if (SingletonConfig.getValue() !== null) {
        config = SingletonConfig.getValue();
    } else {
        const request = new XMLHttpRequest();
        request.open('GET', "/config.json", false); // Solicitud sincrónica
        request.send();

        if (request.status === 200) {
            config = JSON.parse(request.responseText);
            SingletonConfig.setValue(config);
        } else {
            throw new Error('Error en la solicitud fetch');
        }
    }

    if (!config) {
        throw new Error('Error: config undefined');
    }

    // Aquí defines la URL del endpoint desde el config
    if (!config.urlImagenesTarjetas) {
        throw new Error('Error: No se pudo determinar la URL de imágenes de tarjetas');
    }

    // Hacer la petición al endpoint para obtener las imágenes
    return fetch(config.urlImagenesTarjetas)
        .then(response => {
            if (!response.ok) {
                throw new Error('Error al obtener las imágenes de tarjetas');
            }
            return response.json();
        });
    },

    GetKeyReCaptcha: function () {
        let config = null;
    
        if (SingletonConfig.getValue() !== null) {
            config = SingletonConfig.getValue();
        } else {
            const request = new XMLHttpRequest();
            request.open('GET', "/config.json", false); // Solicitud sincrónica
            request.send();
    
            if (request.status === 200) {
                config = JSON.parse(request.responseText);
                SingletonConfig.setValue(config);
            } else {
                throw new Error('Error en la solicitud fetch');
            }
        }
    
        if (!config) {
            throw new Error('Error: config undefined');
        }
    
        if ( !config.keygoogle) {
            throw new Error('Error: No se pudo determinar la clave de ReCaptcha');
        }

        return config.keygoogle;
    },    
    GetUrlBase: function() {
        let config = null;
    
        if (SingletonConfig.getValue() !== null) {
            config = SingletonConfig.getValue();
        } else {
            const request = new XMLHttpRequest();
            request.open('GET', "/config.json", false); // Solicitud sincrónica
            request.send();
    
            if (request.status === 200) {
                config = JSON.parse(request.responseText);
                SingletonConfig.setValue(config);
            } else {
                throw new Error('Error en la solicitud fetch');
            }
        }
    
        if (!config) {
            throw new Error('Error: config undefined');
        }
    
        if (!config.apiUrl) {
            throw new Error('Error: No se pudo determinar la URL base');
        }
    
        return config.apiUrl;
    },    
    GetConfigTarjetas: function () {
        let config = null;

        if (SingletonConfig.getValue() != null) {
            config = SingletonConfig.getValue();
        } else {
            const request = new XMLHttpRequest();

            request.open('GET', "/config.json", false); // El tercer parámetro "false" indica una solicitud sincrónica
            request.send();

            if (request.status === 200) {
                config = JSON.parse(request.responseText);
                SingletonConfig.setValue(config);
                console.info("Valor para 'tarjetas' recuperado del config.json: " + config);
            } else {
                throw new Error('Error en la solicitud fetch');
            }
        }

        if (config === null) throw new Error('Error config undefined');

        const tarjetas = Number(config.tarjetas);

        // Validar el valor de tarjetas
        if (![1, 2, 3].includes(tarjetas)) {
            console.warn("⚠️ Valor inválido para 'tarjetas'. Usando el predeterminado: 'ambas' (3).");
            return 3; // Valor predeterminado en caso de error
        }

        return tarjetas; // Retorna el valor validado de tarjetas
    },
    GetEnableDebug: function () {
        let config = null;

        if (SingletonConfig.getValue() !== null) {
            config = SingletonConfig.getValue();
        } else {
            const request = new XMLHttpRequest();
            request.open('GET', "/config.json", false); // Solicitud sincrónica
            request.send();

            if (request.status === 200) {
                config = JSON.parse(request.responseText);
                SingletonConfig.setValue(config);
            } else {
                throw new Error('Error en la solicitud fetch');
            }
        }

        if (!config) {
            throw new Error('Error: config undefined');
        }

        // Convertir a booleano si está definido, de lo contrario, devolver `false` por defecto
        return config.enableDebug === "true" || config.enableDebug === true;
    },
    GetReferido: function(): string {
        // 1. Carga la config y obtiene el tiempo de vencimiento en horas
        let config = null;

        if (SingletonConfig.getValue() !== null) {
            config = SingletonConfig.getValue();
            console.log("[GetReferido] Config recuperada del SingletonConfig:", config);
        } else {
            const request = new XMLHttpRequest();
            request.open('GET', "/config.json", false);
            request.send();

            if (request.status === 200) {
                config = JSON.parse(request.responseText);
                SingletonConfig.setValue(config);
                console.log("[GetReferido] Config cargada desde config.json:", config);
            } else {
                console.error("[GetReferido] Error en la solicitud fetch a config.json");
                throw new Error('Error en la solicitud fetch');
            }
        }

        if (!config) {
            console.error("[GetReferido] Error: config undefined");
            throw new Error('Error: config undefined');
        }

        // Valor por defecto en horas, si no está definido
        const vtoCacheHoras = parseInt(config.vtoCache) || 24;
        const vtoCacheMs = vtoCacheHoras * 60 * 60 * 1000;

        // Funciones auxiliares para manejar el cache con vencimiento
        function setWithExpiry(key: string, value: string, ttlMs: number) {
            const now = Date.now();
            const item = {
                value: value,
                expiresAt: now + ttlMs,
            };
            localStorage.setItem(key, JSON.stringify(item));
            console.log(`[GetReferido] Guardado en localStorage: { key: ${key}, value: ${value}, expiresAt: ${new Date(item.expiresAt).toISOString()} }`);
        }

        function getWithExpiry(key: string): string | null {
            const itemStr = localStorage.getItem(key);
            if (!itemStr) {
                console.log(`[GetReferido] No existe ${key} en localStorage`);
                return null;
            }

            try {
                const item = JSON.parse(itemStr);
                if (!item.expiresAt || Date.now() > item.expiresAt) {
                    console.log(`[GetReferido] Valor expirado o sin expiresAt (${key}):`, item);
                    localStorage.removeItem(key);
                    return null;
                }
                console.log(`[GetReferido] Valor válido recuperado de localStorage (${key}):`, item.value);
                return item.value;
            } catch (e) {
                console.warn(`[GetReferido] Error parseando localStorage (${key}):`, e);
                localStorage.removeItem(key);
                return null;
            }
        }

        // 2. Buscar el parámetro "codigoReferido" en la URL (case-insensitive)
        const urlParams = new URLSearchParams(window.location.search);
        const paramRaw = urlParams.get("codigoReferido");
        const param = paramRaw ? paramRaw.toLowerCase() : null;

        if (param) {
            // Si existe el parámetro, lo guardo con expiración y lo devuelvo
            setWithExpiry("codigoReferido", param, vtoCacheMs);
            console.log("[GetReferido] Referido recuperado de la URL:", param);
            return param;
        }

        // 3. Si no, lo busco en localStorage con expiración
        const storedReferido = getWithExpiry("codigoReferido");
        if (storedReferido) {
            console.log("[GetReferido] Referido recuperado de localStorage:", storedReferido);
            return storedReferido.toLowerCase();
        }

        // 4. Si no, devuelvo "columbia" y lo guardo
        setWithExpiry("codigoReferido", "columbia", vtoCacheMs);
        console.log("[GetReferido] No se encontró codigoReferido, se usa y guarda 'columbia'.");
        return "columbia";
    }  
}